module.exports = __webpack_public_path__ + "static/gd-abf60fa617872d0f9b7d87094c8bd7c6.jpg";